export default __webpack_public_path__ + "static/media/piper-tilden-crop.2a83b6c6.jpg";